import { api } from 'api';
import { Config, SingleResultDto } from '@fanadise/common-types';

export const fetchConfig = async () => {
  const res = await api.get<SingleResultDto<'config', Config>>('/config');
  return res.data.config;
};
